var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
export var componentWithProps = function (props) {
    if (!props || !props.ComponentType) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }
    // Using Object destructuring or rest operator to remove ComponentType key
    var _a = props, ComponentType = _a.ComponentType, childProps = __rest(_a, ["ComponentType"]);
    return React.createElement(ComponentType, __assign({}, childProps));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/componentWithProps.tsx
// module id = 86
// module chunks = 3